import { render, staticRenderFns } from "./SingleCategory.vue?vue&type=template&id=c3037608"
import script from "./SingleCategory.vue?vue&type=script&lang=ts"
export * from "./SingleCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports